import React from "react"
import { useTranslation } from "react-i18next"
import { Grid, Paper, Typography, styled } from "@mui/material"
import { buttonClasses } from "@mui/base/Button"

import { Content, Card } from "pages/sessions/elements"
import Title from "components/Sessions/Title"
import Button from "components/ui/Button"

const BanksPage = () => {
  const { t } = useTranslation()

  // TODO: use api to fetch available banks list
  const BANKS = [
    {
      color: "#eb8d3e",
      link: "https://www.swedbank.ee",
      title: t("banks.swedbank.title"),
    },
    {
      color: "#000",
      link: "https://lhv.ee",
      title: t("banks.lhv.title"),
    },
    {
      color: "#70bF39",
      link: "https://www.seb.ee",
      title: t("banks.seb.title"),
    },
    {
      color: "#411734",
      link: "https://luminor.ee",
      title: t("banks.luminor.title"),
    },
  ]

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleClick = (link: string) => {}

  return (
    <Content data-testid="login-banks-page">
      <Card elevation={0}>
        <Title back />
        <Wrapper elevation={0}>
          <Headline variant="h2">{t("providers.banks.title")}</Headline>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            {BANKS.map(({ color, link, title }, index: number) => (
              <BankButton
                key={index}
                color={color}
                onClick={() => handleClick(link)}
              >
                {title}
              </BankButton>
            ))}
          </Grid>
        </Wrapper>
      </Card>
    </Content>
  )
}

export default BanksPage

const Wrapper = styled(Paper)(({ theme }) => ({
  borderRadius: "17px",
  marginBottom: "38px",
  [theme.breakpoints.up("sm")]: {
    padding: "41px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0px",
  },
}))

const Headline = styled(Typography)`
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 41px;
`

const BankButton = styled(Button)`
  border: none;
  background-color: #f2f2f2;
  border-radius: 21.5px;
  flex-basis: 50%;
  height: 43px;
  margin: 16px 10px;
  max-width: 149px;

  &.${buttonClasses.root} {
    color: ${({ color }) => color};
  }
`
